export class FicheOfa {
  promo_categorie_id: any;
  promo_priorite: any;
  promo_commentaire: any;
  aug_montant: any;
  aug_priorite: any;
  aug_commentaire: any;
  gratif_taux: any;
  gratif_priorite: any;
  gratif_commentaire: any;
  bonus_montant: any;
  bonus_priorite: any;
  check_switch: any;
  bonus_commentaire: any;
  commentaire: any;
  commentaireArbitrage: any;
  commentaire_retourne: any;
  constructor(promo_categorie_id: any, promo_priorite: any, promo_commentaire: any, aug_montant: any, aug_priorite: any,
    aug_commentaire: any, gratif_taux: any, gratif_priorite: any, gratif_commentaire: any, bonus_montant: any, bonus_priorite: any,
    bonus_commentaire: any, commentaire: any, commentaireArbitrage: any, check_switch: any, commentaire_retourne: any) {
    this.promo_categorie_id = promo_categorie_id;
    this.promo_priorite = promo_priorite;
    this.promo_commentaire = promo_commentaire;
    this.aug_montant = aug_montant;
    this.aug_priorite = aug_priorite;
    this.aug_commentaire = aug_commentaire;
    this.gratif_taux = gratif_taux;
    this.gratif_priorite = gratif_priorite;
    this.gratif_commentaire = gratif_commentaire;
    this.bonus_montant = bonus_montant;
    this.bonus_priorite = bonus_priorite;
    this.bonus_commentaire = bonus_commentaire;
    this.commentaire = commentaire;
    this.commentaireArbitrage = commentaireArbitrage;
    this.commentaire_retourne = commentaire_retourne;
    this.check_switch = check_switch;
  }
}
